import * as React from "react";
import Button from "components/form/button";
import { formatMessage } from "lib/globalize-util";
import { DATATEST } from "constants/integration";

const styles = {
    width: "100%",
};

const ContactButton = ({ model, onShowContacts }) => {
    return model.hasMarketplaceReps ? (
        <div style={styles}>
            <Button
                data-test={DATATEST.LOGIN.CONTACT_REP}
                label={formatMessage("contact a sales rep")}
                onClick={onShowContacts}
                style={{ width: "100%" }}
            />
        </div>
    ) : null;
};

export { ContactButton };
export default ContactButton;
